import type en from '../en/monitoring'
import type { Translation } from '../types'

/** Monitoring and alerts */
const monitoring: Translation<typeof en> = {
  "monitoring.subtitle": "État en temps réel de tous les sites",
  "monitoring.online": "En ligne",
  "monitoring.warning": "Avertissement",
  "monitoring.offline": "Hors ligne",
  "monitoring.awaitingVpn": "En attente du VPN",
  "monitoring.noData": "Aucune donnée",
  "monitoring.lastSeen": "Vu pour la dernière fois {when}",
  "monitoring.alertsActive": { one: "{count} alerte active", other: "{count} alertes actives" },
  "monitoring.alertsResolved": { one: "{count} alerte résolue", other: "{count} alertes résolues" },
  "monitoring.active": "Actives",
  "monitoring.resolved": "Résolues",
  "monitoring.noResolved": "Aucune alerte résolue",
  "monitoring.allClear": "Tout va bien !",
  "monitoring.noneResolvedYet": "Aucune alerte n’a encore été résolue.",
  "monitoring.healthy": "Aucune alerte active — votre réseau fonctionne bien.",
  "monitoring.acknowledge": "Acquitter",
  "monitoring.acknowledged": "✓ Acquittée",
  "monitoring.resolvedWhen": "✓ Résolue {when}",
  "monitoring.category.VPN": "VPN",
  "monitoring.category.cellular": "cellulaire",
  "monitoring.category.device": "appareil",
  "monitoring.category.firmware": "micrologiciel",
  "monitoring.category.license": "licence",
  "monitoring.category.link": "liaison",
  "monitoring.category.speedfusion": "speedfusion",
  "monitoring.category.sync": "synchronisation",
  "monitoring.category.wan": "wan",
  "monitoring.category.wifi": "wi-fi",
}

export default monitoring
